import * as React from "react";
import { Storage } from "aws-amplify";
import ReactPlayer from "react-player";
import styled from "styled-components";

import { Text } from "src/library/components/Text/Text";

export interface S3VideoProps {
  className?: string;
  s3Key: string | undefined;
  level: "public" | "protected" | "private";
  height?: number | string;
  width?: number | string;
}

const S3Video: React.ReactFCWithChildren<S3VideoProps> = ({
  className, s3Key, level, width, height
}) => {
  const [ imgData, setImgData ] = React.useState<string | undefined>();
  const [ loadError, setLoadError ] = React.useState<boolean>(false);

  const fetchVideo = async () => {
    setLoadError(false);

    // Only run if s3Key is valid
    if (s3Key && s3Key.length > 0) {
      // Attempt to get the requested image from S3 using Amplify Storage
      Storage.get(s3Key, {
        level,
        download: false
      })
        .then(data => {
          if (typeof data === "string") {
            return setImgData(data);
          }
        })
        .catch(error => {
          console.error(error);
          setLoadError(true);
        });
    }
  };

  // Load the requested image (on mount and on key change)
  React.useEffect(() => {
    fetchVideo();
  }, [ s3Key ]);

  return (
    <div className={className}>
      {!!imgData && (
        <StyledPlayer
          width={width}
          height={height}
          url={imgData}
          playing
          controls
        />
      )}

      {loadError && (
        <Text>
          Sorry, this video is currently unavailable!
        </Text>
      )}
    </div>
  );
};

const StyledPlayer = styled(ReactPlayer)`
  video {
    outline: none;
  }
`;

export default S3Video;
